import {combineReducers} from "redux";
import list from "./list";
import deleteRole from "./delete";
import create from "./create";
import update from "./update"

export default combineReducers({list, deleteRole, create, update});
